<template>
    <div class="h-12 bg-white w-full rounded-full border-2 border-indigo-500 flex justify-between gap-1 text-sm font-bold">
        <div
          v-for="option in options"
          :key="option.id"
          class="rounded-full w-full flex items-center justify-center cursor-pointer"
          :class="modelValue == option.id ? 'bg-indigo-500 text-white hover:bg-indigo-600' : 'hover:bg-gray-200'"
          @click="$emit('update:modelValue', option.id)"
        >
            {{ option.title }}
            {{ !option.is_available && modelValue == option.id ? '⚠️' : '' }}
        </div>
    </div>
</template>

<script>
import {defineComponent} from 'vue'

export default defineComponent({
    props: {
        options: Array,
        modelValue: {
            required: true
        }
    },
})
</script>
